import React, { useState } from 'react';

import { IResourceComponentsProps, useShow } from '@pankod/refine-core';
import {
  Show,
  RefreshButton,
  TextField,
  Row,
  Col,
  MarkdownField,
  TagField,
  ListButton,
  Space,
  Button,
  useModalForm,
} from '@pankod/refine-antd';

import { SubmissionTypes } from 'interfaces';
import { FORM_STATUS } from 'constant';
import { LeadModal } from 'components';

const SubmissionData: React.FC<IResourceComponentsProps> = () => {
  const [status, setStatus] = useState<string>('');
  const { queryResult } = useShow<SubmissionTypes>({
    resource: 'formSubmissions',
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'phone',
        'country',
        'company',
        'message',
        'createdAt',
        'status',
        'updatedAt',
      ],
    },
  });

  // Create Modal
  const {
    modalProps: createModalProps,
    formProps: createFormProps,
    show: createModalShow,
  } = useModalForm<any>({
    action: 'create',
    resource: 'leads',
    warnWhenUnsavedChanges: true,
  });

  const { data, isLoading }: any = queryResult;
  const record = data?.data;

  return (
    <Show
      isLoading={isLoading}
      headerProps={{
        extra: (
          <Space>
            <Button
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderColor: 'red',
              }}
              type='dashed'
              onClick={
                record?.status === FORM_STATUS.SPAM
                  ? undefined
                  : () => {
                      createModalShow();
                      setStatus(FORM_STATUS.SPAM);
                    }
              }
            >
              {record?.status === FORM_STATUS.SPAM
                ? 'Marked As Spam'
                : 'Mark As Spam'}
            </Button>
            <Button
              type='primary'
              onClick={
                record?.status === FORM_STATUS.LEAD
                  ? undefined
                  : () => {
                      createModalShow();
                      setStatus(FORM_STATUS.LEAD);
                    }
              }
            >
              {record?.status === FORM_STATUS.LEAD
                ? 'Marked As Lead'
                : 'Mark As Lead'}
            </Button>
            <ListButton />
            <RefreshButton onClick={() => queryResult?.refetch()} />
          </Space>
        ),
      }}
    >
      <Row gutter={[0, 10]}>
        <Col span={24}>
          <TextField strong value='Status' />
        </Col>
        <Col span={24}>
          <Button
            style={
              record?.status === FORM_STATUS.LEAD
                ? {}
                : record?.status === FORM_STATUS.QUERY
                ? {
                    backgroundColor: 'orange',
                    color: 'white',
                    borderColor: 'orange',
                  }
                : {
                    backgroundColor: 'red',
                    color: 'white',
                    borderColor: 'red',
                  }
            }
            type={record?.status === FORM_STATUS.LEAD ? 'primary' : 'default'}
          >
            {record?.status}
          </Button>
        </Col>
        <Col span={24}>
          <TextField strong value='ID' />
        </Col>
        <Col span={24}>
          <TagField value={record?.id} />
        </Col>
        <Col span={24}>
          <TextField strong value='Name' />
        </Col>
        <Col span={24}>
          <TagField value={record?.name} />
        </Col>
        <Col span={24}>
          <TextField strong value='Email' />
        </Col>
        <Col span={24}>
          <TagField value={record?.email} />
        </Col>
        <Col span={24}>
          <TextField strong value='Phone' />
        </Col>
        <Col span={24}>
          <TagField value={record?.phone} />
        </Col>
        <Col span={24}>
          <TextField strong value='Country' />
        </Col>
        <Col span={24}>
          <TagField value={record?.country ?? '----'} />
        </Col>
        <Col span={24}>
          <TextField strong value='Company' />
        </Col>
        <Col span={24}>
          <TagField value={record?.company ?? '----'} />
        </Col>
        <Col span={24}>
          <TextField strong value='Message' />
        </Col>
        <Col span={24}>
          <MarkdownField value={record?.message} />
        </Col>
      </Row>

      <LeadModal
        createModalProps={createModalProps}
        createFormProps={createFormProps}
        id={record?.id}
        status={status}
      />
    </Show>
  );
};

export default SubmissionData;
